import { trackLikelyQrEntry } from './src/services/analytics';

// Runs once per full page load, after the first page has rendered. It does not run
// on client-side route changes, so this is exactly "the page the visitor landed on".
export const onInitialClientRender = () => {
    trackLikelyQrEntry();
};
